import { Card } from "@/components/ui/card";

interface McpRawResponseProps {
  responseData: string;
}

export function McpRawResponse({ responseData }: McpRawResponseProps) {
  return (
    <Card className="p-3">
      <h4 className="text-sm font-medium text-foreground mb-2">Raw Response</h4>
      <pre className="text-xs bg-muted p-2 rounded overflow-x-auto whitespace-pre-wrap">
        {responseData}
      </pre>
    </Card>
  );
}
